import IOSRequest from "@/plugins/rhRequest/iOSRequest";
import AxiosRequest from "@/plugins/rhRequest/axiosRequest";

export default {
  install (Vue) {
    Vue.prototype.$rhRequest = window?.cordova?.platformId.toLowerCase() === 'ios' ? new IOSRequest() : new AxiosRequest();
  }
}
